import { Stack, Typography } from '@mui/material';

import { QUERY_KEY } from '~common';
import { AutoCompleteSingleField } from '~components/atoms/custom';
import { RECORD_STATUS } from '~types';

type Props = {
  venueTypeId?: string | null;
};

export const SelectPlacementTypeStep: React.FC<Props> = ({
  venueTypeId = null,
}) => {
  return (
    <Stack gap={2}>
      <Typography variant="h6" fontWeight={600}>
        What type of Placement is this?
      </Typography>
      <AutoCompleteSingleField
        required={true}
        placeholder="Search Placement type"
        name="placement.placementType"
        path={'api/placement-type/list'}
        bodyRequest={{
          venueTypeId: venueTypeId,
          status: RECORD_STATUS.ACTIVE,
        }}
        queryKey={[QUERY_KEY.GET_LIST_PLACEMENT_TYPE]}
      />
    </Stack>
  );
};
